<template>
  <label class="checkbox-label" :for="identifier" :class="{ disabled: disabled }">
    <input
      :id="identifier"
      type="checkbox"
      class="checkbox iw-visuallyhidden"
      :name="groupName"
      :disabled="disabled"
      :value="payload || label"
      :checked="isChecked"
      @change="changeModel($event.target.value)"
    />
    <span class="custom-checkbox checked"></span>
    <span class="custom-checkbox unchecked"></span>
    <slot></slot>
  </label>
</template>

<script>
export default {
  name: "AppCheckbox",
  props: {
    groupName: String,
    label: String,
    modelValue: Array,
    disabled: Boolean,
    payload: [String, Number, Boolean]
  },
  computed: {
    isChecked() {
      return this.modelValue?.includes(String(this.payload)) || this.modelValue?.includes(this.label);
    },
    identifier() {
      return `${this.groupName} - ${this.label || this.payload}`;
    }
  },
  methods: {
    changeModel: function(item) {
      if (this.modelValue.includes(item)) {
        this.$emit(
          "update:modelValue",
          this.modelValue.filter(index => index !== item)
        );
      } else {
        this.$emit("update:modelValue", [...this.modelValue, item]);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.checkbox {
  margin-left: 12px;
}
.checkbox-label {
  display: flex;
  align-items: center;
  word-break: break-word;
  padding-right: 10px;
  cursor: pointer;
}

body.user-is-tabbing .checkbox-label input:focus ~ .custom-checkbox {
  outline: 2px solid $group-2-color-3 !important; /* for non-webkit browsers */
  outline: 2px auto -webkit-focus-ring-color !important;
}

.disabled {
  opacity: 0.4;
}

.checked {
  display: none;
  transform: scale(0.67);
  background-color: $group-3-color-4;

  &__border {
    border: 1px solid $border-color;
  }

  &::before {
    content: "";
    position: absolute;
    top: 10px;
    left: 5px;
    width: 17px;
    height: 3px;
    background-color: $primary-color;
    transform: rotate(-45deg);
  }

  &::after {
    content: "";
    position: absolute;
    top: 13px;
    left: 2px;
    width: 9px;
    height: 3px;
    background-color: $primary-color;
    transform: rotate(45deg);
  }
}

.unchecked {
  display: inline-block;
  background-color: transparent;
}

.checked,
.unchecked {
  position: absolute;
  min-width: 24px;
  height: 24px;
  margin-right: 10px;
  border: 1px solid $border-color;
  border-radius: 3px;
}

.checkbox:checked + .checked {
  display: inline-block;
}
</style>
